// extracted by mini-css-extract-plugin
module.exports = {"marquee":"featured-in_marquee__QFLoW"};